import React from 'react'
import { Button, Modal, Space } from 'antd'
import { ExclamationCircleOutlined, SaveOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

/**
 * 盤點單編輯頁底部黏底 action bar。
 * dirtyCount > 0 才顯示；failedCount 顯示紅色提示。
 *
 * Props:
 *   dirtyCount: number
 *   failedCount: number
 *   saving: boolean
 *   onSaveAll: () => void
 *   onDiscardAll: () => void
 */
export default function StickyActionBar({ dirtyCount, failedCount, saving, onSaveAll, onDiscardAll }) {
  const { t } = useTranslation()

  if (dirtyCount === 0) return null

  const handleDiscard = () => {
    Modal.confirm({
      title: t('shared.stock_takings.show.spreadsheet.discard_confirm_title'),
      icon: <ExclamationCircleOutlined />,
      content: t('shared.stock_takings.show.spreadsheet.discard_confirm_content', { count: dirtyCount }),
      okText: t('shared.stock_takings.show.spreadsheet.discard'),
      cancelText: t('common.action.cancel'),
      okButtonProps: { danger: true },
      onOk: onDiscardAll
    })
  }

  return (
    <div style={{
      position: 'sticky',
      bottom: 0,
      background: '#fff',
      borderTop: '1px solid #f0f0f0',
      padding: '12px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      zIndex: 10
    }}>
      <div>
        <span style={{ fontWeight: 500 }}>
          {t('shared.stock_takings.show.spreadsheet.changed_count', { count: dirtyCount })}
        </span>
        {failedCount > 0 && (
          <span style={{ marginLeft: 12, color: '#ff4d4f' }}>
            {t('shared.stock_takings.show.spreadsheet.failed_hint', { count: failedCount })}
          </span>
        )}
      </div>
      <Space>
        <Button onClick={handleDiscard} disabled={saving}>
          {t('shared.stock_takings.show.spreadsheet.discard')}
        </Button>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          loading={saving}
          onClick={onSaveAll}
        >
          {t('shared.stock_takings.show.spreadsheet.save_all', { count: dirtyCount })}
        </Button>
      </Space>
    </div>
  )
}
